//@ts-check
import getPrettyError from './getPrettyError';
/**
 * @type {import("./types").getPrettyErrorType}
 */

export default (function (error) {
  if (typeof error === 'string') return error;
  if (error && error.payload) return getPrettyError(error.payload);

  if (error && error.response) {
    var r = error.response;
    if (r.body && r.body.Message) return r.body.Message;
    if (r.text) return r.text;
    if (r.error && r.error.message) return r.error.message;
  }

  if (error && error.text) return error.text;
  return error.message || error.Message || 'Unknown error';
});